import React from 'react';
import { Typography, TypographyColor } from '../typography/typography';
import { useAccentBgContext } from '../accent-bg-context/accent-bg-context';
import styles from './form-helper-text.module.scss';

type Props = {
  id: string;
  children: string;
  disabled?: boolean;
};

export const FormHelperText: React.FC<Props> = ({ id, children, disabled }) => {
  const { isAccentBackground } = useAccentBgContext();

  let textColor: TypographyColor = 'black';
  if (isAccentBackground) textColor = 'white';
  if (disabled) textColor = 'anthrazit-50';

  return (
    <Typography className={styles.root} color={textColor} id={id} tag="span" variant="smalltext">
      {children}
    </Typography>
  );
};
